export const INTUIT_EDUCATION_URL = 'https://www.intuit.com/partners/education-program/products/quickbooks/';

export const QUICKBOOKS_DESKTOP_COLLECT_INFO_CLICK_TRACKING = 'edu-educators-qbdesktop-form-submit-button';
export const QUICKBOOKS_ONLINE_COLLECT_INFO_CLICK_TRACKING = 'edu-educators-qbo-form-submit-button';
export const PRO_CONNECT_COLLECT_INFO_CLICK_TRACKING = 'edu-educators-proconnect-form-submit-button';

export const QUICKBOOKS_DESKTOP_DOC_UPLOAD_CLICK_TRACKING = 'edu-educators-qbdesktop-form-upload-button';
export const QUICKBOOKS_ONLINE_DOC_UPLOAD_CLICK_TRACKING = 'edu-educators-qbo-form-upload-button';
export const PRO_CONNECT_DOC_UPLOAD_CLICK_TRACKING = 'edu-educators-proconnect-form-upload-button';

export const REPOSITION_MESSAGE = 'reposition';
export const EDUCATOR_PORTAL_LINK = 'https://education-portal.app.intuit.com/app/dashboard';

